const disabledTimeZone = (time:string) => {
  return time.replace(/[+Z].*$/, "");
};

export default disabledTimeZone;
